import { Injectable } from '@angular/core';
import { ExtensionCommunicationService } from '@shared/extension';
import { AbstractViewStore } from './abstract';

@Injectable()
export class ViewStore extends AbstractViewStore {
  constructor(protected extensionCommunicationService: ExtensionCommunicationService) {
    super(extensionCommunicationService);
  }
}
